import { getKeys } from 'shared/lib/object';

import { GroupCheckbox } from './GroupCheckbox';
import { YearWrapper } from './YearWrapper';
import { AddAnotherDate } from './AddAnotherDate';
import { SelectedCounter } from './SelectedCounter';
import { useHolidaysActions, useHolidaysValues } from './store/store';
import { getCheckboxName, getNumOfSelectedHolidaysInYear, isAllYearChecked } from './lib';
import { Month } from './Month';
import { monthsNameToNumber } from './constants';

interface ScheduleProps {
  className?: string;
}

const isCurrentMonth = (year: string, month: string) => {
  const date = new Date();
  const currYear = date.getFullYear();
  const currMonth = date.getMonth() + 1;

  if (Number(year) === currYear && monthsNameToNumber[month] === currMonth) {
    return true;
  }

  return false;
};

export function Schedule({ className }: ScheduleProps) {
  const { setYearIsChecked } = useHolidaysActions();
  const holidays = useHolidaysValues();

  if (!holidays) {
    return null;
  }

  return (
    <div className={className}>
      {getKeys(holidays).map((year, i) => {
        const isYearChecked = isAllYearChecked(holidays, year);
        const name = getCheckboxName(year);

        return (
          <YearWrapper
            year={year}
            key={year}
            titleClassName="mx-[69px]"
            arrowClassName="mr-[69px]"
            isShadow={i === 0}
          >
            <div className="mx-[69px]">
              <GroupCheckbox
                name={name}
                className="mt-1"
                isChecked={isYearChecked}
                onClick={() => setYearIsChecked({ year, isChecked: !isYearChecked })}
              >
                <div className="text-sm">Select all</div>
              </GroupCheckbox>
              {getKeys(holidays[year])
                .sort((a, b) => monthsNameToNumber[a] - monthsNameToNumber[b])
                .map((month) => {
                  return (
                    <Month
                      key={month}
                      holidays={holidays}
                      year={year}
                      month={month}
                      shouldScrollToElement={isCurrentMonth(year, month)}
                    />
                  );
                })}

              <AddAnotherDate
                className="mt-4"
                year={Number(year)}
              />
              <SelectedCounter
                className="ml-1 mt-4"
                counter={getNumOfSelectedHolidaysInYear(holidays, year.toString())}
              />
              {getKeys(holidays).length - 1 !== i && <div className="mt-[22px] h-[1px] w-full bg-slate-100" />}
              {getKeys(holidays).length - 1 === i && <div className="mt-7" />}
            </div>
          </YearWrapper>
        );
      })}
    </div>
  );
}
